import { Component, DestroyRef, inject, Input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl } from '@angular/forms';
import { LearningTrailsService } from '@app/core';
import { notNull, selectedEntityActive } from '@app/shared/utils';
import { AppSelectors } from '@app/store';
import { AppState } from '@app/store/app.state';
import { Store } from '@ngrx/store';
import { BehaviorSubject } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';

@Component({
  selector: 'app-select-category',
  templateUrl: './select-category.component.html',
  standalone: false,
})
export class SelectCategoryComponent {
  private readonly store = inject(Store<AppState>);
  private readonly destroyRef = inject(DestroyRef);
  private readonly learningTrailsService = inject(LearningTrailsService);
  @Input() public events = false;
  public dataCtrl = new FormControl();
  public data$ = new BehaviorSubject<any[]>([]);

  constructor() {
    this.store.select(AppSelectors.ActiveUser).pipe(
      takeUntilDestroyed(this.destroyRef),
      notNull(),
      switchMap((user) => {
        const selectedEntity = selectedEntityActive(user)[0];
        return this.events
          ? this.learningTrailsService.categorys(selectedEntity, this.events)
          : this.learningTrailsService.categorys(selectedEntity);
      }),
      map((resp) => resp.data),
      tap((data) => this.data$.next(data)),
    );
  }
}
